<div class="ov ov--light">
  <header class="ov-head">
    <h1>{{ t('coNav.overview', 'Главная') }}</h1>
    <p>{{ t('coOverview.subtitle', 'Главное на сегодня по вашим запросам, перевозкам и поставкам') }}</p>
  </header>

  <div *ngIf="loading" class="pp-card"><div class="pp-loading">{{ t('common.loading', 'Загрузка...') }}</div></div>

  <ng-container *ngIf="!loading">
    <!-- Плитки с цифрами -->
    <section class="ov-tiles">
      <a class="ov-tile" [class.ov-tile--accent]="awaitingChoice.length > 0" routerLink="/cargo-owner/dashboard/requests">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/></svg></span>
        <small>{{ t('coOverview.awaitingChoice', 'Ждут выбора экспедитора') }}</small>
        <strong>{{ awaitingChoice.length }}</strong>
        <span *ngIf="bidsToReview > 0">{{ t('coOverview.bidsCame', 'Пришло') }} {{ bidsLabel(bidsToReview) }} ›</span>
        <span *ngIf="bidsToReview === 0">{{ t('coNav.freightRequests', 'Запросы на перевозку') }} ›</span>
      </a>
      <a class="ov-tile" routerLink="/cargo-owner/dashboard/deals">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span>
        <small>{{ t('coOverview.activeDeals', 'Перевозки в работе') }}</small>
        <strong>{{ activeDeals.length }}</strong>
        <span>{{ t('coNav.deals', 'Сделки') }} ›</span>
      </a>
      <a class="ov-tile" [class.ov-tile--warn]="withDebt.length > 0" routerLink="/cargo-owner/dashboard/deals">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10h18M7 15h4"/></svg></span>
        <small>{{ t('coOverview.toPay', 'К оплате по счетам') }}</small>
        <strong>{{ homeSum(deals, 'debt') }}</strong>
        <em class="ov-tile__more" *ngIf="homeOthers(deals, 'debt') as o">{{ o }}</em>
        <span>{{ withDebt.length ? t('coOverview.unpaidDeals', 'Неоплаченных сделок') + ': ' + withDebt.length : t('coOverview.allPaid', 'Всё оплачено') }}</span>
      </a>
      <a class="ov-tile" routerLink="/cargo-owner/dashboard/supplies">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg></span>
        <small>{{ t('coOverview.supplies', 'Поставки в обработке') }}</small>
        <strong>{{ suppliesInWork ?? '—' }}</strong>
        <span>{{ t('coNav.supplies', 'Мои поставки') }} ›</span>
      </a>
    </section>

    <!-- Итоги за всё время -->
    <section class="pp-card ov-stats ov-stats--8">
      <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></svg></span>{{ t('ffOverview.totals', 'Итоги') }}</h2>
      <dl>
        <!-- Сверху — сделки по этапам -->
        <div>
          <dt>{{ t('ffOverview.dealsTotal', 'Всего сделок') }}</dt>
          <dd>{{ deals.length }}</dd>
        </div>
        <div>
          <dt>{{ t('ffOverview.preparing', 'Подготовка') }}</dt>
          <dd>{{ preparingCount }}</dd>
        </div>
        <div>
          <dt>{{ t('ffOverview.inTransit', 'В пути') }}</dt>
          <dd>{{ inTransitCount }}</dd>
        </div>
        <div>
          <dt>{{ t('ffOverview.delivered', 'Доставлено') }}</dt>
          <dd>{{ deliveredCount }}</dd>
        </div>
        <!-- Снизу — вес и деньги -->
        <div>
          <dt>{{ t('ffOverview.totalWeight', 'Общий вес грузов') }}</dt>
          <dd>{{ deliveredWeightText }}</dd>
          <small class="ov-stats__hint">{{ t('ffOverview.deliveredOnly', 'доставленных') }}</small>
        </div>
        <div>
          <dt>{{ t('ffOverview.totalFreight', 'Стоимость перевозок') }}</dt>
          <dd>{{ homeSum(deals, 'invoiced') }}</dd>
          <small class="ov-stats__more" *ngIf="homeOthers(deals, 'invoiced') as o">{{ o }}</small>
          <small class="ov-stats__hint">{{ t('ffOverview.byInvoices', 'по выставленным счетам') }}</small>
        </div>
        <div>
          <dt>{{ t('coOverview.paid', 'Оплачено') }}</dt>
          <dd>{{ homeSum(deals, 'paid') }}</dd>
          <small class="ov-stats__more" *ngIf="homeOthers(deals, 'paid') as o">{{ o }}</small>
        </div>
        <!-- Выгода от конкурса; пока её нет — сколько ставок получено (ноль на главной не показываем) -->
        <div *ngIf="competitionGainTotal === null || competitionGainTotal > 0; else bidsReceivedTile">
          <dt>{{ t('coOverview.gain', 'Выгода от конкурса') }}</dt>
          <dd>{{ competitionGainTotal === null ? '…' : home(competitionGainTotal) }}</dd>
          <small class="ov-stats__hint">{{ t('coOverview.gainHint', 'выбранные ставки против средней по остальным') }}</small>
        </div>
        <ng-template #bidsReceivedTile>
          <div>
            <dt>{{ t('coOverview.bidsReceived', 'Получено ставок') }}</dt>
            <dd>{{ bidsReceived }}</dd>
            <small class="ov-stats__hint">{{ t('coOverview.bidsReceivedHint', 'по запросам ваших сделок') }}</small>
          </div>
        </ng-template>
      </dl>
    </section>

    <div class="ov-grid">
      <!-- Требует внимания -->
      <section class="pp-card ov-card">
        <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg></span>{{ t('ffOverview.attention', 'Требует внимания') }}</h2>
        <p class="ov-empty" *ngIf="!hasAttention">{{ t('coOverview.allGood', 'Всё в порядке: решений и оплат не ждём.') }}</p>
        <ul class="ov-list" *ngIf="hasAttention">
          <!-- Пришли ставки — выбрать экспедитора -->
          <li *ngFor="let r of awaitingChoice">
            <a [routerLink]="['/cargo-owner/request', r.id]">
              <span class="ov-list__main">
                <b>{{ r.id | docNo:'R':r.createdAt }} · {{ r.fromCity }} → {{ r.toCity }}</b>
                <small>{{ bidsLabel(r.bidsCount || 0) }}</small>
              </span>
              <span class="ov-list__action">{{ t('coOverview.choose', 'Выбрать экспедитора') }} ›</span>
            </a>
          </li>
          <!-- Неоплаченные счета экспедитора -->
          <li *ngFor="let d of withDebt">
            <a [routerLink]="['/cargo-owner/deal', d.id]">
              <span class="ov-list__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>{{ t('ffOverview.unpaid', 'Не оплачено по счетам') }} · {{ d.forwarder }}</small>
              </span>
              <span class="ov-list__action ov-list__action--debt">{{ dealTotals(d.totals, 'debt') }} ›</span>
            </a>
          </li>
          <!-- Переплата экспедитору -->
          <li *ngFor="let d of withOverpay">
            <a [routerLink]="['/cargo-owner/deal', d.id]">
              <span class="ov-list__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>{{ t('coOverview.overpaid', 'Переплата экспедитору') }} · {{ d.forwarder }}</small>
              </span>
              <span class="ov-list__action ov-list__action--over">{{ dealTotals(d.totals, 'overpaid') }} ›</span>
            </a>
          </li>
          <!-- Экспедитор давно не обновлял статус -->
          <li *ngFor="let d of staleShown">
            <a [routerLink]="['/cargo-owner/deal', d.id]" [queryParams]="{ chat: 1 }">
              <span class="ov-list__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>
                  {{ d.lastStatusAt
                    ? t('coOverview.staleFor', 'Статус не обновлялся {n} дн.').replace('{n}', '' + daysSince(d.lastStatusAt))
                    : t('coOverview.noStatus', 'Экспедитор ещё не поставил статус') }} · {{ d.forwarder }}
                </small>
              </span>
              <span class="ov-list__action">{{ t('coOverview.ask', 'Спросить в чате') }} ›</span>
            </a>
          </li>
        </ul>
        <p class="ov-list__more" *ngIf="stale.length > staleShown.length">
          {{ t('coOverview.staleMore', 'И ещё {n} перевозок без свежего статуса').replace('{n}', '' + (stale.length - staleShown.length)) }} —
          <a routerLink="/cargo-owner/dashboard/deals">{{ t('ffOverview.all', 'Все') }} ›</a>
        </p>
      </section>

      <!-- Последние сделки -->
      <section class="pp-card ov-card">
        <div class="ov-card__head">
          <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span>{{ t('coOverview.latestDeals', 'Последние перевозки') }}</h2>
          <a routerLink="/cargo-owner/dashboard/deals">{{ t('ffOverview.all', 'Все') }} ›</a>
        </div>
        <p class="ov-empty" *ngIf="latestDeals.length === 0">{{ t('coOverview.noDeals', 'Сделок пока нет — создайте запрос и выберите ставку.') }}</p>
        <ul class="ov-list" *ngIf="latestDeals.length > 0">
          <li *ngFor="let d of latestDeals">
            <a [routerLink]="['/cargo-owner/deal', d.id]">
              <span class="ov-list__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>{{ d.forwarder }}</small>
              </span>
              <span class="pp-badge" [ngClass]="'pp-badge--' + dealTone(d)">{{ d.stage }}</span>
            </a>
          </li>
        </ul>
      </section>
    </div>
  </ng-container>
</div>
